import * as React from "react";
import { useLocalStorage } from "@grandvisionhq/lib-utils-w3c";
import { WishlistContext } from "./context.js";
const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist, removeWishlist] = useLocalStorage(
    "wishlist"
  );
  return /* @__PURE__ */ React.createElement(WishlistContext.Provider, { value: { localWishlist: wishlist, setWishlist, removeWishlist } }, children);
};
export {
  WishlistProvider
};
//# sourceMappingURL=provider.js.map
